import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/en';
export const locale = {
  lang: 'de',
  data: {
    'CONSULTA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
        'PRODUCTOS': catalogos.productos,
      },
      'TITULO': 'Umfragekalender',
      'SUBTITULO': 'Konsultieren Sie die Informationen der Umfragen, die in der Plattform in einem bestimmten Bereich erstellt wurden',
      'TXT_RANG_DAT':'Geben Sie einen Datumsbereich ein',
      'BTN_CANC':'Abbrechen',
      'BTN_APLI':'Anwenden',
      'MOD_TITT_INFO':'Umfrageinformationen',
      'TXT_NAM_COMPA':'Firmenname:  ',
      'TXT_NAM_TOKEN':'Umfrage-Token:  ',
      'TXT_DAT_LAN':'Startdatum:  ',
      'TXT_DAT_CLOS':'Abschlussdatum:  ',
      'TXT_SUR_STA':'Zustand der Umfrage:  ',
      'TXT_TIP_SUR':'Produkttyp:  ',
      'TXT_YEA_SUR':'Erhebungsjahr:  ',
      'ESTATUS':{
        '0':'Inaktiv',
        '1':'Aktiv',
        '2':'Geschlossen',
      },
      'CAMPOS': {
        'broker': 'Broker',
      },
    }
  }
};
